import { createExternalCalendarEventSanitizer } from '@griply/utils';
import { getErrorReporter } from 'shared/services/error-tracking';

// One handled Sentry event per bad provider record, with the ids needed to find it at the provider.
export const externalCalendarSanitizer = createExternalCalendarEventSanitizer({
  onError: (error, context) =>
    getErrorReporter().captureException(error, {
      tags: {
        source: 'external-calendar-sanitizer',
        dropped: String(context.dropped),
      },
      extra: context,
    }),
});
